var _rect, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuCamIconInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 111,
    rx: 30.2727,
    fill: "#C9C9C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3422 36.5795H80.7271C86.3002 36.5795 90.818 41.0974 90.818 46.6705V74.4204C90.818 79.9935 86.3001 84.5114 80.7271 84.5114H30.2725C24.6995 84.5114 20.1816 79.9935 20.1816 74.4205V46.6705C20.1816 41.0974 24.6995 36.5795 30.2725 36.5795H37.9188C38.5395 31.6018 42.7858 27.75 47.9316 27.75H64.3294C69.4753 27.75 73.7215 31.6018 74.3422 36.5795Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.2852,
    cy: 60.5454,
    r: 13.875,
    fill: "#E9E9E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 52.9785,
    cy: 56.7612,
    r: 13.875,
    fill: "#C9C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuCamIconInactive);
export default __webpack_public_path__ + "static/media/zunu_cam_icon_inactive.146009dccf659bc3beb9df5470ae20e5.svg";
export { ForwardRef as ReactComponent };